import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|History|Audit';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPCandidateHistoryAuditLoc =
	| 'SPCandidateHistoryAuditTitle'
	| 'SPCandidateHistoryAuditTableDue'
	| 'SPCandidateHistoryAuditTableUserName'
	| 'SPCandidateHistoryAuditTableStatus'
	| 'SPCandidateHistoryAuditTableTableTitle'
	| 'SPCandidateHistoryAuditTableStarted'
	| 'SPCandidateHistoryAuditTableCompleted'
	| 'SPCandidateHistoryAuditTableAction'
	| 'SPCandidateHistoryAuditTableAssignButtonLabel'
	| 'SPCandidateHistoryAuditTableUnassignButtonLabel';

export const spCandidateHistoryAuditLocs: LocDefs<SPCandidateHistoryAuditLoc> = {
	SPCandidateHistoryAuditTitle: {
		defaultValue: 'Candidate Audit List',
		description: 'Page title and heading for the candidate history audit page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableDue: {
		defaultValue: 'Due Date',
		description: 'Table column header for the due date.',
		displayPath: `${dpRoot}|Due Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableUserName: {
		defaultValue: 'Assignee',
		description: 'Table column header for the assignee.',
		displayPath: `${dpRoot}|Assignee`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableStatus: {
		defaultValue: 'Status',
		description: 'Table column header for the status.',
		displayPath: `${dpRoot}|Status`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableTableTitle: {
		defaultValue: 'Audit History',
		description: 'Table title for the candidate audit list.',
		displayPath: `${dpRoot}|Table Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableStarted: {
		defaultValue: 'Started',
		description: 'Table column header for the started date.',
		displayPath: `${dpRoot}|Started`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableCompleted: {
		defaultValue: 'Completed',
		description: 'Table column header for the completed date.',
		displayPath: `${dpRoot}|Completed`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableAction: {
		defaultValue: 'View',
		description: 'View audit details action button.',
		displayPath: `${dpRoot}|View Action`,
		displayType: 'Button',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableAssignButtonLabel: {
		defaultValue: 'Assign/Reassign',
		description: 'Assign/Reassign button label.',
		displayPath: `${dpRoot}|Assign/Reassign Button Label`,
		displayType: 'Button',
		...sharedProps,
	},
	SPCandidateHistoryAuditTableUnassignButtonLabel: {
		defaultValue: 'Unassign',
		description: 'Unassign button label.',
		displayPath: `${dpRoot}|Unassign Button Label`,
		displayType: 'Button',
		...sharedProps,
	},
};

export const spCandidateHistoryAuditLocKeys = MapLocKeys<SPCandidateHistoryAuditLoc>(
	spCandidateHistoryAuditLocs
);
export type SPCandidateHistoryAuditLocKeys = typeof spCandidateHistoryAuditLocKeys;
